module.exports = __webpack_public_path__ + "static/image/logo-family/new_logo_one.ver2_0_2.png?5c57c722";